import { proxy } from 'valtio';

import { AppName } from 'models';
import { AppHelpers } from 'helpers/AppHelpers';

import { SessionStorageService } from 'services/SessionStorageService';

// Tagged with who was signed in when it was saved, so logging in or out falls back to the new visitor's default app.
export type LastActiveApp = {
    app: AppName; // DCIDE or RE+Source PRO
    userId?: string | null; // null = anonymous, undefined = page was an app router page
};

const readLastActiveApp = (value: unknown) => {
    const lastActiveApp = value as LastActiveApp | null | undefined;

    return AppHelpers.isValidAppName(lastActiveApp?.app) ? lastActiveApp : undefined;
};

export const currentAppState = proxy<{
    lastActiveApp?: LastActiveApp; // Which app was the page you just came from in?
}>({
    // The last active app lives in session storage because
    // moving between the app and pages routers is a full page load
    lastActiveApp: readLastActiveApp(SessionStorageService.get(AppHelpers.storageKey.lastActiveApp)),
});
